 /*
 Create By Sittikron : 20/06/2023
 Update By Sittikron : 9/08/2023  - เพิ่ม Permissionในการตรวจสอบ
 Update By Sittikron : 28/08/2023 - แก้ไขสิทธิทุกหน้า ที่เรียกการใช้  สิทธิ view  เปลี่ยนวิธีเขียนใหม่  ให้เหมือนหน้า m_project.js
 Update By POOM : 26/01/2024  เวลา return API    มีการใช้  status_ID === 0  ซึ่งผิด  แก้ให้ถูก คือ status_ID === 1
 Update By POOM : 2024-05-13  เวลา return API  ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที
 
*/
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Pathurl from "../Class/Pathurl.json";
import { CP_CheckPermission } from "../Class/Class_Permission"
import { Class_ETC_MsgError, Class_ETC_MsgSuccess, Class_ETC_Warning, Class_ETC_Encrypt,Class_ETC_SessionTimeOut } from "../Class/Class_Etc";
import MsgDescription from "../Class/MsgDescription.json";
import ConfigETC from "../Class/ConfigETC.json";


import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import PaginationActions from "../PartialView/PaginationActions"

function M_permission() {
  
  //#region #####################  Declare a variable   ###################

    const [isFirst, setIsFirst] = useState(true);
    const [isLoadProgress, setIsLoadProgress] = useState(true);   
    const [listPermissionGroup, setListPermissionGroup] = useState([]);
    const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
    const [configData, setConfigData] = useState([]);
    const [ ActEdit ] = useState(Class_ETC_Encrypt("Edit"));
    const [ ActAdd ] = useState(Class_ETC_Encrypt("Add"));
    const maxPerId = listPermissionGroup.reduce((maxId, item) => {
      return item.per_group_id > maxId ? item.per_group_id : maxId;
    }, 0);
    const [isPermissionDel, setIsPermissionDel] = useState(false);
    const [isPermissionAdd, setIsPermissionAdd] = useState(false);

  //#endregion

  //#region #####################  Paging               ###################

    const [page, setPage] = useState(0);
    // eslint-disable-next-line
    const [rowsPerPage, setRowsPerPage] = useState(ConfigETC.rowsPerPage); //

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setPage(0);
    };

  //#endregion

  //#region #####################  open on loead        ###################

    useEffect(() => {
      if (isFirst === true) {
        GetConfig();
        if (isLoadedConfigData === true) {     
          let ckpermission = CP_CheckPermission("master" , ["permission_group_view"] , false , true)
          if (ckpermission === true) {
            setIsPermissionDel(CP_CheckPermission("master" , ["permission_group_delete"] , false , false))
            setIsPermissionAdd(CP_CheckPermission("master" , ["permission_group_add"] , false , false)) 
            BindList_Permission_Group("GET" ,function() {
                setIsFirst(false);
              setIsLoadProgress(false);
            });
          }
        }
      };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadedConfigData]);
    
    async function GetConfig() {
      await fetch("../ConfigData.json")
        .then((res) => res.json())
        .then((data) => {
          setConfigData(data);
          setIsLoadedConfigData(true);
        })
        .catch((err) => err);
    }

  //#endregion

  //#region #####################  Bind Data             ###################

    async function BindList_Permission_Group(isAct , _callback) {

      let token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        "per_group_status": "-1"
      });

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      await fetch(configData.API_URL + "Permission_Getlist", requestOptions)
        .then((response) => response.json())
        .then((result) => {

          if (result.status_ID === 2) 
          {
            Class_ETC_SessionTimeOut();
          }
          else
          {
            if (result.total_Data > 0) {
              if (isAct === "DEL") {
                if (rowsPerPage * (page + 1) > result.total_Data) {
                  let pagenow = Math.ceil(result.total_Data / rowsPerPage);
                  setPage((pagenow === 0 ? 0 : pagenow - 1));
                }
              }
              else if (isAct === "GET") {
                setPage(0);
              }
              setListPermissionGroup(result.data);
              if (_callback != null) {
                _callback();
              }
            } else {
              setListPermissionGroup([]);
              if (_callback != null) {
                _callback();
              }
            }
          }
        })
        .catch((error) => {
          setListPermissionGroup([]);
          if (_callback != null) {
            _callback();
        }
        });
    }

  //#endregion

  //#region ###################  Delete Data   ########################

  function Onclick_DeletePermission(Per_id) {
    document.getElementById("hd_iddel").value = Per_id;
   Class_ETC_Warning(MsgDescription.CFM002, DelPermission);
};

 function DelPermission() {
  setIsLoadProgress(true);

  let token = localStorage.getItem("TStoken");
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer " + token);
  var raw = JSON.stringify({
    "per_group_id": document.getElementById("hd_iddel").value
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  fetch(configData.API_URL + "Permission_Del", requestOptions)

    .then(response => response.json())
    .then(result => {
      if (result.status_ID === 1) {
        
        BindList_Permission_Group("DEL",function() {
          setIsLoadProgress(false);
          Class_ETC_MsgSuccess(MsgDescription.CFM003, null);
        });

      }
      else if (result.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else {
        
        setIsLoadProgress(false);
        Class_ETC_MsgError(result.status_Desc, null);
        
      }
    })
    .catch(error => {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR003, null);
    });
 };
 
//#endregion

  return (
    <>

      {isLoadProgress && (
        <div id="divLoadingProgress" name="divLoadingProgress" align="center" className="divWaiting" >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}

      <Helmet>
        <title>Permission Group list</title>
      </Helmet>

      {/* Content Wrapper. Contains page content */}
        <div className="content-wrapper">
          {/* Content Header (Page header) */}
          <div className="content-header">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <div className="container-fluid">
                  <h1 className="display-5"> <i className="fas fa-lock" /> Permission Group</h1>
                </div>
              </div>
            </div>
          </div>
          {/* /.content-header */}
          {/* Main content */}
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-10 offset-md-1">
                  {/* SELECT2 EXAMPLE */}
                  <div className="card  shadow">
                    <div className="card-header ">
                      
                      <h3 className="card-title">
                         Result <small> ({listPermissionGroup.length} items)</small>
                      </h3>

                        <div className="float-right">
                          <div className="btn-group">                       
                            {(isPermissionAdd === true) &&
                              <Link to    = {"../" + Pathurl.m_permission_ae}
                                    state = {{per_id: Class_ETC_Encrypt(maxPerId.toString()),act: ActAdd}}
                                    className="btn btn-primary btn-sm">
                                <i className="fa fa-plus" /> New Group
                              </Link>
                            }
                          </div>
                        </div>

                      </div>
                      <div className="card-body p-0">
                        <TableContainer>
                          <Table className="table table-head-fixed text-nowrap table-hover">
                            <TableHead>
                              <TableRow>
                                <TableCell style={{width: '3%'}}><b>#</b></TableCell>
                                <TableCell style={{width: '25%'}}><b>Permission Group</b></TableCell>
                                <TableCell style={{width: '15%'}}><b>Desc</b></TableCell>
                                <TableCell style={{width: '10%'}}><b>Staff</b></TableCell>
                                <TableCell style={{width: '10%'}}><b>Status</b></TableCell>
                                <TableCell style={{width: '15%'}} />
                              </TableRow>
                            </TableHead>
                            <TableBody>
                            {(listPermissionGroup.length === 0 && (
                                  <TableRow key={1}>
                                    <TableCell colSpan={6} align="center">
                                      {ConfigETC.NoData}
                                    </TableCell>
                                  </TableRow>
                                )) ||
                                listPermissionGroup
                                    .slice(
                                      page * rowsPerPage,
                                      page * rowsPerPage + rowsPerPage
                                    )
                                    .map((row) => (
                                    <TableRow key={row.per_group_id}>
                                      <TableCell>
                                                  {row.rowindex}
                                                  <input type="hidden" id="hd_iddel" defaultValue={row.per_group_id}></input>                                              
                                      </TableCell>
                                      <TableCell><div>{row.per_group_name}</div></TableCell>
                                      <TableCell>{row.per_group_desc}</TableCell>
                                      <TableCell> <i className="nav-icon fa fa-users" /> <span className="badge bg-gray">{row.staff_cnt}</span></TableCell>
                                      <TableCell>
                                          <span
                                            className={
                                              row.per_group_status === 1
                                                ? ConfigETC.Status_active
                                                : ConfigETC.Status_inactive
                                            }
                                          >
                                            {row.per_group_status_str}
                                          </span>                         
                                      </TableCell>
                                      <TableCell className="text-right py-0 align-middle">
                                        <div className="btn-group btn-group-sm">
                                          <Link to        = {"../" + Pathurl.m_permission_ae}
                                                state     = {{ per_id: Class_ETC_Encrypt(row.per_group_id.toString()),act: ActEdit}}
                                                className ="btn btn-primary" title="Edit">
                                            <i className="fas fa-pencil-alt" />
                                          </Link>
                                          {(isPermissionDel === true) &&
                                            <a href="#!" 
                                              className="btn btn-default" 
                                              title="ลบ"
                                              onClick={() => Onclick_DeletePermission(row.per_group_id.toString())}>
                                              <i className="fas fa-trash"/>
                                            </a>
                                          }
                                        </div>
                                      </TableCell>
                                    </TableRow>
                              ))} 
                            </TableBody>
                          </Table>
                        </TableContainer>
                        {listPermissionGroup.length > 0 && (
                            <TablePagination
                              rowsPerPageOptions={[ConfigETC.rowsPerPage]}
                              component="div"
                              count={listPermissionGroup.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={PaginationActions}
                            />
                      )}
                      </div>
                    {/* /.card-body */}
                  </div>
                  {/* /.card */}
                </div>
              </div>
            </div>{/* /.container-fluid */}
          </section>
          {/* /.content */}
        </div>
      {/* /.content-wrapper */}

    </>
  );
}

export default M_permission;
